<script lang="ts">
    
    import { Button, Icon } from "sveltestrap";
    import type { State } from "../../Model/State";
    import { picturesService } from "../../Services";
    import Picture from "./Picture.svelte";

    export let id: State<string | null>;

    let inputElement: HTMLInputElement;
    let isUploading = false;
    let isDeleting = false;

    async function onInputChange(): Promise<void> {
        const [file] = inputElement.files;
        inputElement.value = '';

        if (isUploading || !file) {
            return;
        }

        isUploading = true;

        try {
            const pictureId = await picturesService.uploadPicture(file);
            id.set(pictureId);
        } catch (error) {
            console.error(error);
        } finally {
            isUploading = false;
        }
    }

    async function onRemove(): Promise<void> {
        if (isDeleting || !confirm('¿Seguro que desea eliminar esta imagen?')) {
            return;
        }
        isDeleting = true;
        try {
            await picturesService.deletePicture(id.value);
            id.set(null);
        } catch (error) {
            console.error(error);
        } finally {
            isDeleting = false;
        }
    }

</script>

<div>
    <input
        type="file"
        accept="image/jpeg,image/png"
        style="display: none;"
        bind:this={inputElement}
        on:change={onInputChange}>

    {#if $id}
        <div class="mb-2">
            <Picture {id} />
        </div>
        <Button type="button" color="danger" size="sm" on:click={onRemove} disabled={isDeleting}>
            <Icon name="x" /> {isUploading ? 'Eliminando...' : 'Eliminar imagen'}
        </Button>
    {:else}
        <Button type="button" color="primary" size="sm" on:click={() => inputElement?.click()} disabled={isUploading}>
            <Icon name="image" /> {isUploading ? 'Subiendo...' : 'Establecer imagen'}
        </Button>
    {/if}
</div>
